<template>
  <div class="indexroot">  
    
    <template v-if="route.params.page === 'my-gravaa'">
      <div class="h-screen flex place-items-center justify-center">
        <p>
          my-gravaa
          
        </p>
      </div>
    </template>

    <!-- C U S T O M  P A G E S (has page and blog)-->

    <template v-else-if="data.page && data.blog">

      <!-- Support -->
      <CustompageSupport v-if="isSlug('support')" :blog="data.blog" />
      <CustompageFaq v-else-if="isSlug('faq')" :blog="data.blog" />
      <!--CustompageUserGuide v-else-if="isSlug('user-guide')" :blog="data.blog" /-->
      <CustompagePress v-else-if="isSlug('press')" :blog="data.blog" />

      <!-- Policy -->
      <CustompagePrivacyPolicy v-else-if="isSlug('privacy-policy')" :blog="data.blog" />
      <CustompageCookiePolicy v-else-if="isSlug('cookie-policy')" :blog="data.blog" />

      <!--CustompageNews      v-else-if="isSlug('news')" :blog="data.blog"/-->

      
      <CustompageHowItWorks v-else-if="isSlug('how-it-works')" :blog="data.blog" />
      <CustompageOurTechnology v-else-if="isSlug('our-technology')" :blog="data.blog" />
      <!--CustompageRollingResistance v-else-if="isSlug('rolling-resistance')" :blog="data.blog" /-->
      <!--CustompageTheGravaaStory v-else-if="isSlug('the-gravaa-story')" :blog="data.blog" /-->
      <CustompageOurTeam v-else-if="isSlug('our-team')" :blog="data.blog" />
      <CustompageStoreLocator v-else-if="isSlug('store-locator')" :blog="data.blog" />
      <CustompageAbout v-else-if="isSlug('about')" :blog="data.blog" />
      <!--CustompageCareers v-else-if="isSlug('careers')" :blog="data.blog" /-->

      <CustompageBlogBasedLayout v-else :blog="data.blog" />
      
      <UiNarrowContent class="text-right">
        <UiParentPageButton v-if="parentPage" :pageId="parentPage" />
      </UiNarrowContent>

      <!--CustompageReturns v-if="isSlug('returns')"/>
      <CustompageTerms v-if="isSlug('terms')"/>
      <CustompageHowItWorks v-if="isSlug('how-it-works')"/-->
    </template>

    <!-- P A G E S (has page in Shopify but no blog top image set via Cover Image)-->
    <template v-else-if="data.page && !data.blog">
      <UiHeroTop v-if="data.page.coverImage"
        :article="{ title: data?.page.title, excerpthtml: '<h1>' + data.page.title + '</h1>', image: data.page.coverImage.reference.image.url }" />
      <UiExtraNarrowContent>                  
          <div class="mt-16 large" v-html="data.page.body"></div>                              
      </UiExtraNarrowContent>
      <ContentContactForm v-if="isSlug('contact')" class="mt-10 mb-0" />
      <UiNarrowContent class="flex text-right">
        <UiParentPageButton v-if="parentPage" :pageId="parentPage" />
      </UiNarrowContent>
    </template>

    <!-- 4 0 4 -->
    <UiContentwrapper class="mt-36" v-else-if="!data.page">
      <UiFullcolumn>
        <h1>404</h1>
        <p>Page does not exist</p>

      </UiFullcolumn>
    </UiContentwrapper>
    
    <ContentFeaturedPages v-if="data.page?.featuredPages || data.page?.featuredCollections"
      :page="data.page" />
      


  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useBlogStore } from '@/stores/blogStore';
import { usePageStore } from '@/stores/pageStore';
import { useHead } from 'nuxt/app';

const { getSeoPageMeta } = useImageUtils();
const { proxy } = useScriptGoogleTagManager({ id: 'GTM-TXPLJB8M' });


const blogStore = useBlogStore();
const pageStore = usePageStore();

const route = useRoute();


const { data, error } = await useAsyncData(route.params.page, async () => {
  const [pageRes, blogRes] = await Promise.all([
    pageStore.fetchPageByHandle(route.params.page),
    blogStore.fetchBlogByHandle(route.params.page)
  ]);
 
  return {
    page: pageRes,
    blog: blogRes    
  };
});

const isSlug = (slug) => route.params.page === slug;

const parentPage = computed(() => {
  try{
    if(data.value.page?.parentPage?.value){
      return data.value.page.parentPage.value;
    }
  } catch (e) {
    console.error('Error fetching parent page:', e);
  }
  return null;
})

// SEO

if (isSlug('faq')) {
  // Förbered FAQ-artiklar
  const faqArticles = computed(() =>
    data.value.blog.articles
      .filter(a => !a.tags?.includes('Herobanner'))
      .map(a => ({ title: a.title, content: a.content, handle: a.handle }))
  )
  useFaqSeo(faqArticles.value)
} else {
  // Alla andra sidor: vanlig SEO/schema
  useHead({
    link: [
      {
        rel: 'canonical',
        href: `https://www.gravaa.com/${route.params.page}`
      }
    ]
   
  });
  const seoMeta = getSeoPageMeta(data.value?.page)
  useSeoMeta(seoMeta);
}

onMounted(async () => {
    
  console.log(`Pushing page_view for ${window.location.href} page to GTM dataLayer`);
  console.log('Page title:', data.value.page?.seo?.title || '');
  proxy.dataLayer.push({ 
    event: 'page_view', 
    pageType: 'other pages',
    pageUrl: window.location.href,
    pageTitle: data.value.page?.seo?.title || ''
  })

});

</script>
